(function (c2) {
  'use strict';

  // For forms that have the server-related boolean fields (checkboxes or
  // toggles) ensure that if "available to all servers" is enabled
  // then "show on servers" is also enabled.
  function enforceParamServerOptions() {
    var $availOnAll = $('#id_available_all_servers');
    var $showOnServers = $('#id_show_on_servers');

    var morpher;
    if ($availOnAll.data('toggle') == 'toggle') {
      morpher = toggleProps;
    } else {
      morpher = setFieldProps;
    }

    $availOnAll.on('change', morpher);
    // To make it do initial form setup
    morpher();

    function setFieldProps(e) {
      if ($availOnAll.prop('checked')) {
        // This field is disabled so won't be posted.  However, the CF model's
        // save method will also enforce this condition.
        $showOnServers.prop('checked', true).prop('disabled', true);
      } else {
        $showOnServers.prop('disabled', false);
      }
    }

    function toggleProps(e) {
      if ($availOnAll.prop('checked')) {
        $showOnServers.bootstrapToggle('on').bootstrapToggle('disable');
      } else {
        $showOnServers.bootstrapToggle('enable');
      }
    }
  }


  c2.params = {
    enforceParamServerOptions: enforceParamServerOptions
  };

})(window.c2);
